import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Tv, ShieldCheck, MapPin } from 'lucide-react';
export function EysHero() {
  return <section className="relative w-full bg-marine-navy overflow-hidden" data-id="element-22">
      <div className="absolute inset-0 bg-wave-pattern opacity-50 pointer-events-none" data-id="element-23" />
      <div className="absolute top-0 right-0 -mr-32 -mt-32 w-80 h-80 rounded-full bg-marine-blue opacity-20 blur-3xl pointer-events-none" data-id="element-24" />
      <div className="absolute bottom-0 left-1/4 w-64 h-64 rounded-full bg-marine-cyan opacity-10 blur-3xl pointer-events-none" data-id="element-25" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16" data-id="element-26">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center" data-id="element-27">
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="lg:col-span-7 text-white" data-id="element-28">
            {/* As seen on badge */}
            <div className="inline-flex items-center gap-2 bg-marine-cyan/10 border border-marine-cyan/30 text-marine-cyan text-xs font-semibold uppercase tracking-wider px-3.5 py-1.5 rounded-full mb-5" data-id="element-29">
              <Tv className="w-4 h-4" data-id="element-30" />
              As Seen on NBC, Fox, CBS &amp; 100s of other sites
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight mb-4 leading-tight" data-id="element-31">
              Get On Board Easier With{' '}
              <span className="text-marine-cyan" data-id="element-32">Extend Your Step</span>
            </h1>

            <p className="text-lg md:text-xl text-slate-200 mb-3 font-semibold" data-id="element-33">
              An Easy-to-Use Boat Boarding Ladder Extension
            </p>
            <p className="text-base text-slate-300 mb-7 max-w-2xl" data-id="element-34">
              The easy way to add a step — extends well into the water so
              getting back aboard is simpler, safer, and more comfortable.
            </p>

            {/* Trust chips */}
            <div className="flex flex-wrap gap-2 mb-7" data-id="element-35">
              <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/10 rounded-full px-3.5 py-1.5 text-xs sm:text-sm font-medium text-slate-200" data-id="element-36">
                <MapPin className="w-4 h-4 text-marine-cyan" data-id="element-37" />
                Made in the USA
              </div>
              <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/10 rounded-full px-3.5 py-1.5 text-xs sm:text-sm font-medium text-slate-200" data-id="element-38">
                <ShieldCheck className="w-4 h-4 text-marine-cyan" data-id="element-39" />
                UV-Stabilized HDPE
              </div>
              <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/10 rounded-full px-3.5 py-1.5 text-xs sm:text-sm font-medium text-slate-200" data-id="element-40">
                Fits Most Boarding Ladders
              </div>
            </div>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-3" data-id="element-41">
              <a href="https://www.clrmarine.com/m4/0CLR_1--extend‑your‑marine‑boarding‑ladder‑clr1.html" className="inline-flex items-center justify-center gap-2 bg-marine-cyan hover:bg-cyan-400 text-marine-navy font-semibold px-5 py-3 rounded-lg transition-colors duration-200" data-id="element-42">
                Purchase Extend Your Step
                <ArrowRight className="w-4 h-4" data-id="element-43" />
              </a>
              <a href="https://www.clrmarine.com/m4/0CLR_3--40‑inch‑marine‑boarding‑ladder‑extension‑0clr-3.html" className="inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 text-white font-medium px-5 py-3 rounded-lg border border-white/20 transition-colors duration-200" data-id="element-44">
                Purchase Extend Your Step Three
                <ArrowRight className="w-4 h-4" data-id="element-45" />
              </a>
            </div>
          </motion.div>

          {/* Hero image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.15
        }} className="lg:col-span-5" data-id="element-46">
            <div className="relative bg-white/5 border border-white/10 rounded-2xl p-4 shadow-2xl shadow-marine-cyan/10" data-id="element-47">
              <img src="//drwzpk38qkpfb.cloudfront.net/www.clrmarine.com/preview/uploaded/images/EXTEND_YOUR_STEP/EYS-5a.jpg?opt=w3" alt="On Extend Your Step it's a lot easier getting on board" title="On Extend Your Step it's a lot easier getting on board" loading="lazy" className="w-full rounded-xl object-cover aspect-[4/3]" data-id="element-48" />
              <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 bg-marine-cyan text-marine-navy text-xs font-bold uppercase tracking-wider px-3 py-1.5 rounded-full whitespace-nowrap" data-id="element-49">
                In Action
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}